module.exports = __webpack_public_path__ + "img/hr.88f38f33.svg";